var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2436 8.28317L22.1697 7.67985C21.036 7.51146 20.0593 6.78624 19.5507 5.73869L17.7301 1.97829C16.4546 -0.658128 12.7687 -0.658128 11.4922 1.97829L9.67155 5.73869C9.16295 6.78624 8.18628 7.51249 7.05257 7.67985L2.97871 8.28317C0.129744 8.70466 -1.01004 12.2801 1.05373 14.3329L3.99895 17.2596C4.8196 18.0737 5.19345 19.2493 5.00095 20.4001L4.30289 24.5335C3.81658 27.4313 6.79928 29.641 9.3514 28.2743L12.9926 26.3217C14.0058 25.7783 15.2175 25.7783 16.2317 26.3217L19.8729 28.2743C22.425 29.641 25.4067 27.4313 24.9214 24.5335L24.2234 20.4001C24.0309 19.2503 24.4047 18.0737 25.2254 17.2596L28.1706 14.3329C30.2344 12.2801 29.0946 8.70466 26.2436 8.28317ZM9.30986 16.0209C8.24099 16.0209 7.37475 14.9248 7.37475 13.5725C7.37475 12.2202 8.23998 11.1272 9.30986 11.1272C10.3797 11.1272 11.245 12.2233 11.245 13.5725C11.245 14.9217 10.3797 16.0209 9.30986 16.0209ZM17.1638 16.0209C16.0949 16.0209 15.2287 14.9248 15.2287 13.5725C15.2287 12.2202 16.0939 11.1272 17.1638 11.1272C18.2336 11.1272 19.0989 12.2233 19.0989 13.5725C19.0989 14.9217 18.2336 16.0209 17.1638 16.0209Z",
    fill: "url(#paint0_linear_2763_9847)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2763_9847",
    x1: 14.6116,
    y1: -0.0000565158,
    x2: 14.6116,
    y2: 28.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectLogo);
export default __webpack_public_path__ + "static/media/connect-logo.509add92edb54b004b744c26d09ddfd7.svg";
export { ForwardRef as ReactComponent };